// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__U3ArC","description":"PatientConsentPreview_description__2yNGO"};